var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-div"},[_c('span',{style:({ fontSize: _vm.fontSize, color: _vm.color })},[_c('a-icon',{staticStyle:{"margin-right":"3px","font-size":"13px"},attrs:{"type":"info-circle"}}),_vm._v(" "+_vm._s(_vm.content)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }